<script lang="ts">
    import { getCachedEntries } from "../../../api"
    import { location } from "../../store"
    import MedialibImage from "../MedialibImage.svelte"
    import MiniLoader from "./widgets/MiniLoader.svelte"
    export let block: ContentBlock<"teamMember">

    const memberIds = block.teamMember.map((member) => member.teamMember)
    const getTeamEntries = async () => {
        const team = await getCachedEntries<"team">("team", {
            _id: { $in: memberIds },
        })
        return memberIds.map((id) => team.find((member) => member.id === id))
    }
    let scrollTargetContainers: HTMLDivElement[] = []
    let scrolled = false
    $: if (typeof window !== "undefined") {
        if (scrollTargetContainers.length) {
            const targetAnchor = $location.hash.split("#").pop()
            const targetContainer = scrollTargetContainers.find((container) => container.id === targetAnchor)
            if (targetContainer && !scrolled) {
                scrolled = true
                targetContainer.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
            }
        }
    }
    //
</script>

<div class="team-container">
    {#await getTeamEntries()}
        <MiniLoader />
    {:then team}
        <ul class="" style="">
            {#each team as member, i}
                <!-- position 100px above -->
                <div style="position:relative; top: -200px;">
                    <div bind:this="{scrollTargetContainers[i]}" id="{member.id}" style="position: absolute;"></div>
                </div>
                <li class="{i % 2 ? 'row-reverse' : 'row'}">
                    <div class="content">
                        <div class="upper">
                            <h2>
                                {#each member.titles as title}
                                    {title}&nbsp;
                                {/each}{member.name}
                            </h2>
                            <ul>
                                {#each member.specialties as specialty}
                                    <li><h3>{specialty}</h3></li>
                                {/each}
                            </ul>
                        </div>
                        <div class="lower">
                            <p>{@html member.vita}</p>
                        </div>
                    </div>
                    <div class="img">
                        <div class="img-wrapper">
                            <MedialibImage id="{member.detailedImage}" />
                            {#if block.teamMember[i]?.background}
                                <div class="background-image">
                                    <MedialibImage id="{block.teamMember[i].background}" />
                                </div>
                            {/if}
                        </div>
                    </div>
                </li>
            {/each}
        </ul>
    {/await}
</div>

<style lang="less" global>
    @import "../../../css/variables.less";
    .team-container {
        & > ul {
            display: flex;
            flex-direction: column;

            & > li {
                margin-bottom: calc(var(--default-gap) * 2);
                &:last-child {
                    margin-bottom: 0;
                }

                display: flex;
                gap: calc(var(--default-gap) * 2.3);
                @media @max-tablet {
                    flex-direction: column-reverse !important;
                    gap: calc(var(--default-gap) / 2);
                }
                .content {
                    display: flex;
                    flex-direction: column;
                    gap: var(--default-gap);
                    .upper {
                        display: flex;
                        flex-direction: column;
                        gap: calc(var(--default-gap) / 2);
                        ul {
                            display: flex;
                            flex-direction: column;
                            gap: 0.6rem;
                        }
                    }
                    .lower {
                        p {
                            font-size: 1rem;
                            line-height: 1.4;
                        }
                    }
                }
                .img {
                    position: relative;
                    width: 100%;
                    z-index: 0;
                    @media @max-tablet {
                        max-width: 100%;
                    }
                    picture {
                        width: 100%;
                    }
                    img {
                        object-fit: contain;
                        width: 100%;
                        height: 100%;
                    }
                    .img-wrapper {
                        position: relative;
                        width: 100%;
                        z-index: 0;
                        height: fit-content;
                    }
                    .background-image {
                        position: absolute;
                        bottom: 6px;
                        left: 0px;
                        right: var(--default-gap);
                        height: 100%;
                        z-index: -1;
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-end;
                        align-items: flex-end;

                        overflow: hidden;
                        picture {
                            width: 100%;
                        }
                        &:nth-child(even) {
                            img {
                                object-fit: cover;
                                width: 100%;
                                height: 100%;
                                border-radius: 6px 6px 48px 6px;
                            }
                        }
                        &:nth-child(odd) {
                            img {
                                object-fit: cover;
                                width: 100%;
                                height: 100%;
                                border-radius: 6px 6px 6px 48px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>
